import utils from 'utils';

class SibluShowMore {
  constructor(elem) {
    this.target = elem;
    // this.showMoreBlock = document.querySelectorAll('.js-show-more__block');
    this.showMoreBlock = elem.querySelectorAll('.js-show-more__block');
    this.target.classList.add('js-show-more--processed');

    this.events();
  }

  events () {
    this.showMoreBlock.forEach((block) => {
      const showMoreBtn = block.querySelector('.js-show-more__button');

      if (showMoreBtn) {
        this.handler(block, showMoreBtn);
      }
    });
  };

  handler (block, showMoreBtn) { 
    showMoreBtn.addEventListener('click', () => {
      block.classList.toggle('expanded');
      block.classList.toggle('collapsed');
      
      // Update button aria-expanded attribute for accessibility
      const isExpanded = block.classList.contains('expanded');
      showMoreBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      // Optionally change the button text when expanded/collapsed
      showMoreBtn.textContent = isExpanded ? Drupal.t('Show less') : Drupal.t('Display more'); 
    });
    this.resizeHandler(block, showMoreBtn, utils.mq.sm);
    utils.mq.sm.addEventListener('change', e => {
      this.resizeHandler(block, showMoreBtn, e);
    }); 
  };

  resizeHandler (block, showMoreBtn, e) {
    let collapseHeight = block.getAttribute('data-collapse-height') ? +block.getAttribute('data-collapse-height') : 440;
    let collapseHeightDesktop = block.getAttribute('data-collapse-height-desktop') ? +block.getAttribute('data-collapse-height-desktop') : 440;
    if (e.matches) {
      // On design mobile height of "block" is 388px in collapsed state.
      // The following logic is - if height of block is bigger than 440px
      // we adding behavior with show/hide button. Why we checking value
      // more than 388px is that for example if our block's height on
      // mobile will be just a little bit more than 388px - it's not
      // making a sense to add show/hide button just to unhide a couple
      // of pixels.
      // So let's add show/hide button only if there is many content to
      // show.
      if (block.scrollHeight > collapseHeight) {
        block.classList.add('collapsed');
        showMoreBtn.classList.remove('d-n');
      }
    } else {
      if (block.classList.contains('expanded')) {
        block.classList.remove('expanded');
        showMoreBtn.setAttribute('aria-expanded', 'false');
      }
      if (block.classList.contains('collapsed')) {
        block.classList.remove('collapsed');
      }
      if (!showMoreBtn.classList.contains('d-n')) {
        showMoreBtn.classList.add('d-n');
      }

      if (block.getAttribute('data-collapse-height-desktop') !== null) {
        if (block.scrollHeight > collapseHeightDesktop) {
          block.classList.add('collapsed');
          showMoreBtn.classList.remove('d-n');
        }
      }
    }
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const sibluShowMoreElements = document.querySelectorAll('.js-show-more:not(.js-show-more--processed)');
  for (let sibluShowMoreElement of sibluShowMoreElements) {
    sibluShowMoreElement.ssm = new SibluShowMore(sibluShowMoreElement);
  }
});